module.exports = __webpack_public_path__ + "static/feature-1-f32fe8187b033ad0fe24ed4d83fd6a9f.svg";